import React, { useState, useEffect, useCallback, useMemo } from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { getActiveProjects, getIskoopProjects } from "../../api/projectsService";
import { FaHourglassHalf, FaCheckCircle } from "react-icons/fa";

const Projects = () => {
  const [projects, setProjects] = useState([]);
  const [iskProjects, setIskProjects] = useState([]);
  const [activeCategory, setActiveCategory] = useState("genel");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        // /projeler sayfasındaki mantıkla: getActiveProjects kullan
        const g = await getActiveProjects(1, 1000, "", "genel");
        if (alive && g?.isSuccess && g?.data) {
          // Sayfalı response'dan items array'ini al
          const items = g.data.items || g.data.Items || [];
          setProjects(items);
        } else if (alive) {
          setProjects([]);
        }
        
        const i = await getIskoopProjects(1, 1000, "");
        if (alive && i?.isSuccess && i?.data) {
          // Sayfalı response'dan items array'ini al
          const items = i.data.items || i.data.Items || [];
          setIskProjects(items);
        } else if (alive) {
          setIskProjects([]);
        }
      } catch (e) {
        if (alive) setError(e?.message || "Veri yüklenemedi");
      } finally {
        if (alive) setLoading(false);
      }
    })();
    return () => { alive = false; };
  }, []);

  const currentProjects = activeCategory === "iskoop" ? iskProjects : projects;

  const makeSlug = useCallback((p) => {
    if (p?.slug) return p.slug;
    const base = (p?.title || "")
      .toString()
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[^a-z0-9\s-]/g, "")
      .trim()
      .replace(/\s+/g, "-")
      .replace(/-+/g, "-");
    return base || String(p?.id || "");
  }, []);

  const isOngoing = (p) => (p?.status || "").toLowerCase().includes("devam");
  const sortedProjects = useMemo(() => {
    const arr = currentProjects || [];
    const done = arr.filter(p => !isOngoing(p));
    const ongoing = arr.filter(p => isOngoing(p));
    return [...done, ...ongoing];
  }, [currentProjects]);

  const CategoryButtons = () => (
    <div
      className="homepage-category-buttons"
      style={{ display: "flex", gap: "12px", marginBottom: "20px", alignItems: "center" }}
    >
      <button
        className={`category-btn ${activeCategory === "genel" ? "active" : ""}`}
        onClick={() => setActiveCategory("genel")}
        style={{
          padding: "8px 16px",
          width: "132px",
          height: "62px",
          border: "2px solid #ddd",
          borderRadius: "25px",
          background: activeCategory === "genel" ? "#0F75BC" : "#fff",
          color: activeCategory === "genel" ? "#fff" : "#333",
          cursor: "pointer",
          fontWeight: "500",
          transition: "all 0.3s ease",
        }}
      >
        GENEL
      </button>
      <button
        className={`category-btn ${activeCategory === "iskoop" ? "active" : ""}`}
        onClick={() => setActiveCategory("iskoop")}
        style={{
          padding: "8px 16px",
          width: "132px",
          height: "62px",
          border: "2px solid #ddd",
          borderRadius: "25px",
          background: activeCategory === "iskoop" ? "#0F75BC" : "#fff",
          color: activeCategory === "iskoop" ? "#fff" : "#333",
          cursor: "pointer",
          fontWeight: "500",
          transition: "all 0.3s ease",
        }}
      >
        {/* <img
          src="/assets/images/iskooplogotransparent.png"
          alt="İSKOOP Logo"
          style={{ width: "104px", height: "44px", objectFit: "contain" }}
        /> */}
        İSKOOP
      </button>
    </div>
  );

  const hasItems = sortedProjects?.length > 0;

  const settings = {
    dots: true,
    infinite: hasItems && sortedProjects.length > 3,
    speed: 500,
    slidesToShow: hasItems ? Math.min(3, sortedProjects.length) : 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: hasItems ? Math.min(2, sortedProjects.length) : 1,
          infinite: hasItems && sortedProjects.length > 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          infinite: hasItems && sortedProjects.length > 1,
        },
      },
    ],
  };

  return (
    <section className="projects-section">
      <div className="services-grid-title">
        <h2>Projelerimiz</h2>
        <p>Devam eden ve tamamlanan projelerimizi bu alandan inceleyebilirsiniz.</p>
      </div>

      <div className="container" style={{ marginBottom: "20px" }}>
        <CategoryButtons />
      </div>

      <div className="projects-grid container">
        {loading ? (
          <div style={{ padding: 24 }}>Yükleniyor…</div>
        ) : error ? (
          <div style={{ padding: 24, color: "#b00020" }}>Hata: {error}</div>
        ) : !hasItems ? (
          <div style={{ padding: 24 }}>Kayıt bulunamadı.</div>
        ) : (
          <Slider {...settings}>
            {sortedProjects.map((p) => {
              const desc = p.summary ?? p.description ?? "";
              const slug = makeSlug(p);
              const fitClass = p.fit === "contain" ? "is-contain" : "is-cover";
              const ongoingNow = isOngoing(p);

              return (
                <div key={p.id ?? slug} className="px-3">
                  <div className="project-card">
                    <div
                      className={`project-card-media ${fitClass}`}
                      style={p.bg ? { backgroundColor: p.bg } : undefined}
                    >
                      <img 
                        src={p.image || "/assets/images/example-post.jpg"} 
                        alt={p.title} 
                        loading="lazy"
                        onError={(e) => {
                          e.target.src = "/assets/images/example-post.jpg";
                        }}
                      />
                    </div>

                    <div className="project-card-body">
                      <h3 className="project-card-title">{p.title}</h3>
                      <p
                        className={`project-card-status ${
                          ongoingNow ? "status-yellow" : "status-green"
                        }`}
                      >
                        {ongoingNow ? (
                          <>
                            <FaHourglassHalf aria-hidden="true" style={{ marginRight: 6 }} />
                            {p.status || "Devam Ediyor"}
                          </>
                        ) : (
                          <>
                            <FaCheckCircle aria-hidden="true" style={{ marginRight: 6 }} />
                            {p.status || "Hizmete Açıldı"}
                          </>
                        )}
                      </p>
                      <p className="project-card-desc">{desc}</p>

                      <Link
                        to={`/projeler/${slug}`}
                        className="project-card-btn"
                        aria-label={`${p.title} projesi detayı`}
                      >
                        Detaya Git
                      </Link>
                    </div>
                  </div>
                </div>
              );
            })}
          </Slider>
        )}
      </div>
    </section>
  );
};

export default Projects;
